export { AssetAllocationBannerWidget } from './AssetAllocationBannerWidget';
